// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6429ca8","455":"2c250bbf","946":"fb59caeb"}[chunkId] + ".chunk.js";
};